export default class Menu {
  constructor() {
    this.header = document.querySelector(".header:not(.header--small)")
    this.hamburger = document.querySelector(
      ".header:not(.header--small) .header__hamburger",
    )

    this.headerSmall = document.querySelector(".header--small")
    this.headerSmallHamburger = document.querySelector(
      ".header--small .header__hamburger",
    )
    this.headerSmallLogo = document.querySelector(
      ".header--small .header__logo",
    )

    this.subHamburger = document.querySelector(".sub-header .sub-header__menu")
    this.subMenu = document.querySelector(".sub-menu")
    this.subToggle = document.querySelector(".sub-menu__toggle")
    this.subMenuNav = document.querySelector(".sub-menu__nav")

    this.megaMenu = document.querySelector(".mega-menu")
    this.megaMenuClose = document.querySelector(".mega-menu .mega-menu__close")

    this.childrenToggle = document.querySelectorAll(".children-toggle")

    this.initMenu()
    this.initProgramMenu()
    this.initMegaMenu()
    this.initChildrenToggle()
  }

  initMenu() {
    if (!this.header || !this.headerSmall) return

    let originalScrollY = 0

    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY
      const hideTriggerHeight = window.innerHeight / 2 + 200

      if (currentScrollY > hideTriggerHeight) {
        this.header.classList.add("header--hide")
        this.headerSmall.classList.add("header--hide")
      } else {
        this.header.classList.remove("header--hide")
        this.headerSmall.classList.remove("header--hide")
      }

      if (
        currentScrollY < originalScrollY &&
        currentScrollY > hideTriggerHeight
      ) {
        this.headerSmall.classList.add("header--show")
      } else if (
        currentScrollY > originalScrollY ||
        currentScrollY <= hideTriggerHeight
      ) {
        this.headerSmall.classList.remove("header--show")
      }

      originalScrollY = currentScrollY

      this.setHeaderTabIndex()
    })

    window.addEventListener("resize", () => {
      this.setHeaderTabIndex()
    })

    document.addEventListener("DOMContentLoaded", () => {
      this.setHeaderTabIndex()
    })
  }

  initProgramMenu() {
    if (!this.subMenu || !this.subToggle || !this.subMenuNav) return

    this.subToggle.addEventListener("click", () => {
      const isExpanded = this.subToggle.getAttribute("aria-expanded") === "true"
      if (isExpanded) {
        $(this.subMenuNav).slideUp(200)
        this.subToggle.setAttribute("aria-expanded", "false")
        this.subToggle.setAttribute("aria-label", "Show Menu")
        this.subToggle.classList.remove("open")
      } else {
        $(this.subMenuNav).slideDown(200)
        this.subToggle.setAttribute("aria-expanded", "true")
        this.subToggle.setAttribute("aria-label", "Hide Menu")
        this.subToggle.classList.add("open")
      }
    })

    let originalScrollY = 0

    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY
      const hideTriggerHeight = window.innerHeight / 2 + 200

      if (currentScrollY > 0) {
        this.subMenu.classList.add("sub-menu--sticky")
      } else {
        this.subMenu.classList.remove("sub-menu--sticky")
      }

      if (currentScrollY > hideTriggerHeight) {
        this.subMenu.classList.add("sub-menu--hide")
      } else {
        this.subMenu.classList.remove("sub-menu--hide")
      }

      if (
        currentScrollY < originalScrollY &&
        currentScrollY > hideTriggerHeight
      ) {
        this.subMenu.classList.remove("sub-menu--hide")
      }

      originalScrollY = currentScrollY
    })
  }

  setHeaderTabIndex() {
    const currentScrollY = window.scrollY
    const windowWidth = window.innerWidth

    if (windowWidth < 768) {
      this.headerSmallLogo.setAttribute("tabindex", "0")
    } else if (windowWidth >= 768 && currentScrollY > 500) {
      this.headerSmallLogo.setAttribute("tabindex", "0")
    } else {
      this.headerSmallLogo.setAttribute("tabindex", "-1")
    }
  }

  initMegaMenu() {
    if (this.hamburger) {
      this.hamburger.addEventListener("click", () => {
        this.toggleMegaMenu()
      })
    }

    if (this.headerSmallHamburger) {
      this.headerSmallHamburger.addEventListener("click", () => {
        this.toggleMegaMenu()
      })
    }

    if (this.subHamburger) {
      this.subHamburger.addEventListener("click", () => {
        this.toggleMegaMenu()
      })
    }

    this.megaMenuClose.addEventListener("click", () => {
      this.toggleMegaMenu()
    })

    this.megaMenu.addEventListener("animationend", (e) => {
      // Only hide after fadeOut animation completes and menu is not active
      if (
        e.animationName === "fadeOut" &&
        this.megaMenu.classList.contains("hidden") &&
        !this.megaMenu.classList.contains("active")
      ) {
        this.megaMenu.setAttribute("aria-expanded", "false")
        this.megaMenu.style.display = "none"
        this.megaMenu.classList.remove("hidden")
      }
    })
  }

  initChildrenToggle() {
    this.childrenToggle.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        const parentLi = e.currentTarget.parentElement
        const childUl = parentLi.querySelector("ul")

        if (childUl) {
          if (childUl.style.display === "block") {
            childUl.style.display = "none"
            e.currentTarget.setAttribute("aria-expanded", "false")
            e.currentTarget.setAttribute("aria-label", "Show Children")
          } else {
            childUl.style.display = "block"
            e.currentTarget.setAttribute("aria-expanded", "true")
            e.currentTarget.setAttribute("aria-label", "Hide Children")
          }
        }
      })
    })
  }

  toggleMegaMenu() {
    if (this.megaMenu.classList.contains("active")) {
      // Start the fade-out animation
      document.body.classList.remove("no-scroll")
      this.megaMenu.classList.remove("active")
      this.megaMenu.setAttribute("aria-expanded", "false")
      this.megaMenu.classList.add("hidden")

      if (this.hamburger) {
        this.hamburger.setAttribute("aria-expanded", "false")
        this.hamburger.setAttribute("aria-label", "Show Full Menu")
      }

      if (this.headerSmallHamburger) {
        this.headerSmallHamburger.setAttribute("aria-expanded", "false")
        this.headerSmallHamburger.setAttribute("aria-label", "Show Full Menu")
      }

      if (this.subHamburger) {
        this.subHamburger.setAttribute("aria-expanded", "false")
        this.subHamburger.setAttribute("aria-label", "Show Sub Menu")
      }
    } else {
      // Ensure menu is visible before starting fade-in
      this.megaMenu.style.display = "block"
      document.body.classList.add("no-scroll")
      this.megaMenu.classList.remove("hidden")
      this.megaMenu.classList.add("active")
      this.megaMenu.setAttribute("aria-expanded", "true")

      if (this.hamburger) {
        this.hamburger.setAttribute("aria-expanded", "true")
        this.hamburger.setAttribute("aria-label", "Close Full Menu")
      }

      if (this.headerSmallHamburger) {
        this.headerSmallHamburger.setAttribute("aria-expanded", "true")
        this.headerSmallHamburger.setAttribute("aria-label", "Close Full Menu")
      }

      if (this.subHamburger) {
        this.subHamburger.setAttribute("aria-expanded", "true")
        this.subHamburger.setAttribute("aria-label", "Close Sub Menu")
      }
    }
  }
}
